<template>
  <div v-if="enableBundleNumberOfPrice == 'yes'">
    <div v-if="bundleNames.length > 0" class="bundle-options">
      <div v-for="(bundle, index) in bundleNames" :key="bundle.key" class="bundle-item"
        :class="{ 'active': bundle.key === keyActive }">
        <span class="bundle-name" @click="changePricebundle(bundle, bundle.key)">
          {{ bundle?.name }}
        </span>
      </div>
      <input type="hidden" name="number_of_bunlde" :value="keyActive">
    </div>
  </div>
  <div
  class="yith-wcpb-product-bundled-items"
  :data-min-distinct="bundleData.bundleAdvanceOptions?.min_distinct"
    :data-max-distinct="bundleData.bundleAdvanceOptions?.max_distinct">
    <div v-for="(product, index) in filteredAttributes" :key="product?.bundle_id"
      class="product yith-wcpb-product-bundled-item" :data-is-purchasable="product?.bundle_stock"
      :data-min-quantity="product.bundle_min_qty" :data-max-quantity="product?.bundle_max_qty">
      <div class="yith-wcpb-product-bundled-item-image alt-layout-bundle"
        @click="show_engraving__modal(product && product.bundle_thumb && product.bundle_thumb.woocommerce_single, product.bundle_title)">
        <div class="alt-engraving__thumbnail">
          <img :src="product?.bundle_thumb?.woocommerce_single" :alt="product?.bundle_title"
            :data-caption="product.bundle_title" />
          <div class="alt-engraving__zoom-hover">
            <img src="/single-product/zoom-icon.webp" alt="zoom-icon" />
          </div>
        </div>
      </div>

      <div class="yith-wcpb-product-bundled-item-data">
        <a class="yith-wcpb-product-bundled-item-data__arrow"
          :href="`${baseUrl.replace(/\/$/, '')}/${product.bundle_slug.replace(/^\//, '')}`">
          <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="https://www.w3.org/2000/svg">
            <path
              d="M0.0799223 9.53856L0.965681 10.4243L5.91992 5.47008L0.965681 0.515834L0.079923 1.40159L4.14841 5.47008L0.0799223 9.53856Z"
              fill="#9D9D9D"></path>
          </svg>
        </a>
        <h3 class="yith-wcpb-product-bundled-item-data__title">
          <a :href="`${baseUrl.replace(/\/$/, '')}/${product.bundle_slug.replace(/^\//, '')}`" class=""
            :data-product_id="product.bundle_id">
            {{ product.bundle_title }}
          </a>
        </h3>
        <template v-if="product.bundle_type === 'simple'">

          <div class="yith-wcpb-product-bundled-item-data__price">
            <div class="price">
              <!-- Regular Price Display -->
              <template v-if="product.bundle_fake_price && product.bundle_fake_price !== '0' && !perItemPricing">
                <ins>
                  {{ wooStore.currency.symbol }}{{ displayPrice(product.bundle_fake_price) }}
                </ins>
              </template>
              <template v-else>
                <template v-if="parseInt(product?.bundle_discount, 10) >= 0">
                  <ins>
                    <span class="woocommerce-Price-amount amount">
                      <bdi>

                        {{ wooStore.currency.symbol }}{{
                          displayPrice(calculateDiscountedPrice(product.bundle_price.regular_price,
                            product?.bundle_discount)) }}
                      </bdi>
                    </span>
                  </ins>

                </template>

                <ins v-else>

                  <span class="woocommerce-Price-amount amount">
                    <bdi>
                      {{ wooStore.currency.symbol }}{{ displayPrice(product.bundle_price.regular_price) }}
                    </bdi>
                  </span>
                </ins>

                <!-- Sale Price Display -->

              </template>

            </div>
          </div>
        </template>

        <!-- variable -->

        <div class="yith-wcpb-product-bundled-item-data__price"
          v-if="product.bundle_type === 'variable' && parseInt(bundleDefaults[index + 1]?.variationPrice) > 0">

          <template v-if="perItemPricing">
            <div class="price">
              <template v-if="parseInt(bundleDefaults[index + 1]?.salePrice) > 0">
                <ins>
                  <span class="woocommerce-Price-amount amount">
                    <bdi>
                      {{ wooStore.currency.symbol }}{{
                        displayPrice(bundleDefaults[index + 1]?.salePrice) }}
                    </bdi>
                  </span>
                </ins>
              </template>

              <!-- Sale Price Display -->
              <ins v-else>
                <span class="woocommerce-Price-amount amount">
                  <bdi>
                    {{ wooStore.currency.symbol }}{{ displayPrice(bundleDefaults[index + 1]?.variationPrice) }}
                  </bdi>
                </span>
              </ins>
            </div>

          </template>
          <template v-else>
            <template v-if="product.bundle_fake_price && product.bundle_fake_price !== '0'">

              <span class="fakeprice_item price">
                <ins>
                  <span class="woocommerce-Price-amount amount">
                    <bdi>
                      {{ wooStore.currency.symbol }}{{ displayPrice(product.bundle_fake_price) }}
                    </bdi>
                  </span>
                </ins>
              </span>

            </template>
            <div class="price" v-else>
              <ins>
                <span class="woocommerce-Price-amount amount">
                  <bdi>
                    <span class="woocommerce-Price-currencySymbol" v-html="wooStore.currency.symbol">
                    </span>{{ displayPrice(bundleDefaults[index + 1]?.variationPrice) }}
                  </bdi>
                </span>
              </ins>
            </div>
          </template>


        </div>

        <div v-if="product.bundle_size_guide !== null">
          <SizeGuide :data="product.bundle_size_guide" />
        </div>
        <input v-if="product.bundle_type === 'variable'" type="hidden" :name="`yith_bundle_variation_id_${index + 1}`"
          class="variation_id" :class="{ mandatoryVariation: !shouldShowOptionalProduct(product) }"
          :value="bundleDefaults[index + 1]?.id_variation" :data-item-id="index + 1" />

        <input type="hidden" :name="`yith_bundle_quantity_${index + 1}`" class="variation_quantity" value="1"
          :data-item-id="index + 1" min="1" max="1" />

        <input v-if="product.bundle_type === 'simple'" type="hidden" name="p_item_id" class="p_item_id"
          :value="product.bundle_id" />
        <!-- Bundle Optional -->
        <div :class="[
          'yith-wcpb-product-bundled-item-data__optional yith-wcpb-bundled-optional-wrapper',
          { is_number_of_price: enableBundleNumberOfPrice === 'yes' }
        ]" v-if="shouldShowOptionalProduct(product)">
          <input v-model="isItemChecked[`${product.bundle_id}_${index + 1}`]" type="checkbox"
            :name="`yith_bundle_optional_${index + 1}`" :id="`yith_bundle_${product.bundle_id}optional_${index + 1}`"
            :checked="enableBundleNumberOfPrice === 'yes'" :class="[
              'yith-wcpb-bundled-optional'
            ]" :data-item-id="index + 1"
            @change="handleCheckboxChange($event, index + 1, `${product.bundle_id}_${index + 1}`, product, product.bundle_discount)">

          <label :for="`yith_bundle_${product.bundle_id}optional_${index + 1}`">Add item to bundle</label>
        </div>
        <div v-if="product?.bundle_type === 'variable' && productIsValid(product)"
          v-show="enableBundleNumberOfPrice === 'yes' || product.bundle_optional !== 'yes' || (product.bundle_optional == 'yes' && isItemChecked[`${product.bundle_id}_${index + 1}`])"
          class="yith-wcpb-product-bundled-item-data__attributes">
          <div v-if="productIsValid(product)" v-for="(attributeGroup, groupIndex) in product.filteredAttributes"
            :key="groupIndex" class="bundled-options__select-variation">
            <div class="bundled-options__variation-selector"
              @click="toggleDropdown(product.bundle_id, groupIndex, index)">
              <div class="bundled-options__variation-selected">
                <div class="bundled-options__variation-label">{{ getAttributeName(attributeGroup) }}</div>
                <div class="bundled-options__selected">
                  {{ bundleDefaults[index + 1]?.defaultAttributes?.[groupIndex] || 'Select' }}
                </div>
              </div>
            </div>
            <select :id="`yith_bundle_attribute_${getAttributeGroupSlug(attributeGroup)}_${index + 1}`"
              class="yith-wcpb-select-for-variables" :name="`yith_bundle_attribute_${getAttributeGroupSlug(attributeGroup)}_${index + 1}`

                ">
              <option value="">Choose an Option</option>
              <option v-for="attribute in attributeGroup" :key="attribute.slug" :value="attribute.slug"
                :selected="bundleDefaults[index + 1]?.defaultAttributes?.[groupIndex] == attribute.value">{{
                  attribute.value }}</option>
            </select>

            <ul class="bundled-options__variation-items" v-if="isDropdownOpen(product.bundle_id, groupIndex, index)">
              <li v-for="attribute in attributeGroup" :key="attribute.slug"
                @click="selectAttribute(attribute.value, attribute.slug, product.bundle_id, groupIndex, index, product, getAttributeGroupSlug(attributeGroup), $event)">
                <span class="bundled-options__variation-name">{{ attribute.value }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="yith-wcpb-product-bundled-item-data__availability yith-wcpb-product-bundled-item-availability not-variation"
          v-if="product?.bundle_type === 'variable' && !productIsValid(product)">
          <span class="stock out-of-stock 11">Out Of Stock</span>
        </div>
        <div class="yith-wcpb-product-bundled-item-data__quantity"
          v-if="Number(product?.bundle_min_qty) !== Number(product?.bundle_max_qty)">
          <input step="1" :min="product.bundle_min_qty" :max="product.bundle_max_qty"
            :name="`yith_bundle_quantity_${index + 1}`" :value="product?.bundle_min_qty" title="Qty"
            :data-item-id="index + 1" class="yith-wcpb-bundled-quantity" :size="product?.bundle_max_qty" type="number"
            required="true"
            @input="validateQuantity($event, Number(product?.bundle_min_qty), Number(product?.bundle_max_qty))"
            :class="{ invalid: isInvalid }">
          <div class="yith-wcpb-bundled-quantity__invalid-notice">
            You can choose a minimum quantity of <span class="yith-wcpb-bundled-quantity__invalid-notice__min-qty">{{
              product?.bundle_min_qty }}</span> and a maximum quantity of <span
              class="yith-wcpb-bundled-quantity__invalid-notice__max-qty">{{ product.bundle_max_qty }}</span> for this
            product!
          </div>
        </div>
        <div v-if="product?.bundle_type === 'simple'"
          class="yith-wcpb-product-bundled-item-data__availability yith-wcpb-product-bundled-item-availability not-variation">
          <span v-if="product.bundle_stock" class="stock in-stock">In Stock</span>
          <span v-else class="stock out-of-stock 22">Out Of Stock</span>
        </div>

        <div class="action_bundle" v-if="product.bundle_type === 'variable'"
        :class="{
          unactive: product.bundle_optional == 'yes' && !isItemChecked[`${product.bundle_id}_${index + 1}`] && enableBundleNumberOfPrice !== 'yes'
        }">
          <div v-if="bundleDefaults[index + 1]?.status == 'instock'">
            <span class="stock in-stock">In Stock</span>
          </div>
          <div v-else-if="bundleDefaults[index + 1]?.status == 'oos' || bundleDefaults[index + 1]?.status == 'outofstock'">
            <span class="stock out-of-stock 33">Out Of Stock</span>
          </div>
          <div v-else>

          </div>
          <div v-if="bundleDefaults[index + 1]?.status != ''">
            <span class="clear" @click="clearSelection(product, product.bundle_id, index)">Clear</span>
          </div>

        </div>
      </div>
    </div>
    <div class="alt-engraving__modal" id="alt-engraving__modal">
      <span class="alt-engraving__modal-close" @click="close_engraving__modal">×</span>
      <div class="alt-engraving__modal-image">
        <img :src="modalImgSrc" alt="" />
      </div>
      <div class="alt-engraving__modal-captions" v-html="modalCaption"></div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/scss/components/product/_bundleditems.scss";
@import "@/assets/scss/components/product/_sizeguide.scss";
</style>

<script setup lang="ts">
import { ref, computed, nextTick } from 'vue';
import SizeGuide from "~/components/Product/SingleProduct/Layouts/SizeGuide.vue";
import { displayPrice, displayCustomPrice } from '~/utils/displayPrice';
const wooStore = useWooStore();
const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;
const emit = defineEmits(['updatePrice', 'update:isStatusBundle'])
const initialFilteredAttributes = ref({})
const calculateDiscountedPrice = (regularPrice, discount) => {
  const price = parseFloat(regularPrice) || 0;
  const discountValue = parseFloat(discount) || 0;
  return Math.round(price * (1 - discountValue / 100));
};
interface Attribute {
  attribute: string;
  name: string;
  value: string;
  slug: string;
}

interface PostMeta {
  meta_key: string;
  meta_value: string;
}

interface Variation {
  id: number;
  attrs: Record<string, string>;
  product: {
    PostMeta: PostMeta[];
  };
}

interface BundlePrice {
  price: string;
  regular_price: string;
}

interface Product {
  bundle_id: number;
  bundle_order: string;
  bundle_selection_attribute: string;
  bundle_variation_ids: string;
  bundle_discount: string;
  bundle_type: string;
  bundle_title: string;
  bundle_slug: string;
  bundle_optional: string;
  bundle_stock: boolean;
  bundle_fake_price: string;
  bundle_min_qty: string;
  bundle_max_qty: string;
  bundle_price: BundlePrice;
  bundle_size_guide: string | null;
  bundle_thumb: {
    woocommerce_single: string;
  };
  bundle_attributes: Attribute[][];
  bundle_variations: Variation[];
  filteredAttributes?: Attribute[][];
}
interface IBundleItemSettings {
  [key: string]: string | null | Record<number, number> | Record<string, string>;
  bundle_order: string;
  product_id: string;
  bp_filtered_variations: Record<number, number>;
  bp_selection_overrides: Record<string, string>;
  bp_show_name: string;
  bp_title: string | null;
  bp_show_description: string;
  bp_description: string;
  bp_discount: string;
  bp_min_qty: string;
  bp_max_qty: string;
  fake_price: string;
};
interface IBundleData {
  bundleData: IBundleItemSettings,
  bundleVersion: string;
  bundlePerItemPricing: string;
  bundleShowSavingAmount: string;
  bundleNoShiping: string;
  enableBundleNumberOfPrice: string;
  inforBundleNumberOfPrice: string;
  bundleAdvanceOptions: {
    min: string;
    max: string;
    min_distinct: string;
    max_distinct: string;
  },
  bundleProduct: Product[]
}
interface IBundleProps {
  data: { bundleDataProduct: IBundleData },
}

interface Props {
  data: { bundleData: IBundleProps, }
}
interface TotalAccumulator {
  regularPrice: number;
  salePrice: number;
}

const props = defineProps<IBundleProps & { isStatusBundle: boolean }>();
const bundleData = computed(() => props.data.bundleDataProduct);
const bundleVariationIdDefault = ref<Record<string, string | number>>({})

interface IBundleDefault {
  id_variation: string;
  status: string;
  discount: string;
  bundle_type: string;
  bundle_optional: string;
  variationPriceInit: string;
  variationPrice: string;
  salePrice: string;
  defaultAttributes: Record<number, string>;
  bundle_price?: {
    regular_price: string | number;
    price: string | number;
  };
}


const isItemChecked = ref<boolean[]>([]);
interface BundleItem {
  key: number;
  name: string;
  regularPrice: string;
  salePrice: string;
}
interface BundleItemData {
  'item-onoff': string;
  [key: string]: string;
}
const enableBundleNumberOfPrice = props.data.bundleDataProduct?.enableBundleNumberOfPrice;
const inforBundleNumberOfPrice = (props.data.bundleDataProduct?.inforBundleNumberOfPrice || {}) as Record<string, BundleItemData>;
const bundleNames: BundleItem[] = [];

Object.entries(inforBundleNumberOfPrice).forEach(([index, item]) => {
  if (item['item-onoff'] === 'yes') {
    const nameKey = `_yith_wcpb_emm_name_${index}_bundle`;
    const regularPriceKey = `_yith_wcpb_emm_price_${index}_bundle_regular`;
    const salePriceKey = `_yith_wcpb_emm_price_${index}_bundle_sale_price`;
    if (parseInt(item[regularPriceKey]) > 0) {
      bundleNames.push({
        key: parseInt(index),
        name: item[nameKey],
        regularPrice: item[regularPriceKey],
        salePrice: item[salePriceKey]
      });
    }
  }
});

const changePricebundle = (bundle: BundleItem, index: number) => {
  const updatedPriceInfo = {
    regular_price: bundle.regularPrice,
    sale_price: bundle.salePrice,
    price: Number(bundle.salePrice) > 0 ? bundle.salePrice : bundle.regularPrice
  };
  keyActive.value = index;
  emit('updatePrice', updatedPriceInfo);
  selectedValues.value = new Map();
  bundleValid.value = [];
  isItemChecked.value = {};
  initialFilteredAttributes.value = JSON.parse(JSON.stringify(filteredAttributes.value));
  bundleDefaults.value = Object.keys(bundleData.value.bundleData).reduce((result, key) => {
    let key2 = parseInt(key) - 1;
    const bundleItem = bundleDataProduct.value[key2]
    if (bundleItem?.bundle_type === 'simple') {
      //result[key] = bundleItem
      result[key] = {
        id_variation: bundleItem.bundle_id,
        status: bundleItem?.bundle_stock ? 'instock' : 'outofstock',
        discount: bundleItem?.bundle_discount,
        variationPrice: bundleItem?.bundle_price?.regular_price || 0,
        salePrice: '',
        defaultAttributes: []
      }
    } else {
      bundleVariationIdDefault.value[key] = bundleItemDefault(key)?.id_variation || ''
      result[key] = bundleItemDefault(key)
    }

    return result
  }, {} as Record<string, any>)
  
  nextTick(() => {
    validateBundleStatus();
  });
};

const bundleDataProduct = computed(() => bundleData.value.bundleProduct);
const perItemPricing = bundleData.value.bundlePerItemPricing === 'yes' ? true : false;

const shouldShowOptionalProduct = (product: Product) => {
  if (!product.bundle_stock) return false;

  // Check if filteredAttributes is undefined or empty array
  if (!product.filteredAttributes || product.filteredAttributes.length === 0 && product.bundle_type === 'variable') return false;

  if (product.bundle_optional !== 'yes') return false;

  return true;
};
const productIsValid = (product) => {
  if (!product.bundle_stock) return false;

  // Check for empty array specifically
  if (
    (product.filteredAttributes == '' ||
      product.filteredAttributes.length === 0 ||
      Array.isArray(product.filteredAttributes) && product.filteredAttributes.length === 0) &&
    product.bundle_type === 'variable'
  ) {
    return false;
  }
  return true;
};

const bundleItemDefault = (order_bundle: string): IBundleDefault | null => {
  let priceItem = ''
  let statusVariation = ''
  let salePriceValue = ''  // Move declaration to outer scope

  const dataBundleItems = bundleData.value.bundleData[order_bundle] || [];
  if (!dataBundleItems.bp_selection_overrides ||
    Object.keys(dataBundleItems.bp_selection_overrides).length === 0) {
    if (bundleData.value.bundleProduct[order_bundle]?.bundle_price) {
      const prices = bundleData.value.bundleProduct[order_bundle]?.bundle_price;
      return {
        id_variation: dataBundleItems.product_id,
        status: '',
        bundle_type: 'variable',
        abcde: 'variable',
        bundle_optional: dataBundleItems?.bp_optional,
        variationPriceInit: prices?.regular_price || 0,
        discount: dataBundleItems?.bp_discount,
        variationPrice: prices?.regular_price || 0,
        salePrice: '',
        defaultAttributes: []
      }
    }

    return null
  }

  const bp_selection_overrides = dataBundleItems.bp_selection_overrides
  const index = parseInt(order_bundle) - 1
  const bundle_variations = bundleData.value.bundleProduct[index]?.bundle_variations

  if (!bundle_variations) {
    return {
      id_variation: '',
      status: '',
      discount: '',
      variationPrice: '',
      salePrice: '',
      defaultAttributes: []
    }
  }
  const matchingVariation = bundle_variations.find(variation => {
    const matchAttributes = Object.entries(bp_selection_overrides).every(([key, value]) => {
      const attrKey = `attribute_${key}`
      return variation.attrs[attrKey] === value
    })

    const stockMeta = variation.product.PostMeta.find(
      meta => meta.meta_key === '_stock_status'
    )

    const regularPrice = variation.product.PostMeta.find(
      meta => meta.meta_key === '_regular_price'
    )

    const salePrice = variation.product.PostMeta.find(
      meta => meta.meta_key === '_price'
    )
    if (matchAttributes && stockMeta?.meta_value === 'instock') {
      priceItem = variation.product?.bundle_fake_price &&
        parseInt(variation.product.bundle_fake_price) > 0
        ? variation.product.bundle_fake_price
        : regularPrice?.meta_value || ''

      statusVariation = stockMeta?.meta_value || 'oos'
      salePriceValue = salePrice?.meta_value || ''

      const existingIndex = selectedVariationIds.value.findIndex(
        item => item.bundleId === parseInt(dataBundleItems?.product_id)
      )

      if (existingIndex === -1) {
        selectedVariationIds.value.push({
          index,
          bundleId: parseInt(dataBundleItems?.product_id),
          variationId: variation.id
        })
      } else {
        selectedVariationIds.value[existingIndex] = {
          index,
          bundleId: parseInt(dataBundleItems?.product_id),
          variationId: variation.id
        }
        const keyvalid2 = index + '-' + parseInt(dataBundleItems?.product_id)
        if (!bundleValid.value.includes(keyvalid2) && dataBundleItems.bp_optional != 'yes') {
          bundleValid.value.push(keyvalid2)
        }
        if (enableBundleNumberOfPrice == 'yes' && dataBundleItems.bp_optional == 'yes') {
          bundleValid.value.push(keyvalid2);
        }
      }

      return true
    }
    return false
  })
  const transformToNumericKeys = (obj: Record<string, string>): Record<number, string> => {
    return Object.values(obj).reduce((acc, value, index) => {
      acc[index] = value
      return acc
    }, {} as Record<number, string>)
  }
  const bundleDiscount = parseInt(dataBundleItems.bp_discount)
  const bundle_optional = dataBundleItems.bp_optional;

  return matchingVariation ? {
    id_variation: matchingVariation.id.toString(),
    status: statusVariation,
    //variationPrice: bundle_optional == 'yes' ? 0 : priceItem,
    variationPrice: enableBundleNumberOfPrice !== 'yes' && bundle_optional == 'yes' ? 0 : priceItem,
    bundle_type: 'variable',
    bundle_optional: bundle_optional,
    variationPriceInit: priceItem || 0,
    discount: bundleDiscount,
    salePrice: bundleDiscount > 0
      ? Math.round(priceItem * (1 - bundleDiscount / 100))
      : '',
    defaultAttributes: transformToNumericKeys(bp_selection_overrides)
  } : {
    id_variation: '',
    status: '',
    discount: '',
    variationPrice: '',
    salePrice: '',
    defaultAttributes: []
  }
}

const bundleDefaults = ref<Record<string, IBundleDefault>>({
  'initial': {
    id_variation: '',
    status: '',
    discount: '',
    variationPrice: '',
    salePrice: '',
    defaultAttributes: {}
  }
})

const filteredAttributes = computed(() => {
  const allFilteredProducts = Object.values(bundleDataProduct.value).map((product) => {
    const hasSelectedAttributes = Object.values(product?.bundle_selection_attribute || {}).some(value => value !== '')
    const selectedAttributes = product.bundle_selection_attribute;
    // const isValidVariation = product.bundle_variations.some(variation => {
    //   return Object.entries(selectedAttributes).every(([key, value]) => {
    //     const attributeKey = `attribute_${key}`;
    //     return variation.attrs[attributeKey] === value;
    //   });
    // });
    const isValidVariation = product.bundle_variations.some(variation => {
      if (!selectedAttributes) {
        return false;
      }

      return Object.entries(selectedAttributes).every(([key, value]) => {
        const attributeKey = `attribute_${key}`;
        return variation.attrs[attributeKey] === value;
      });
    });


    if (hasSelectedAttributes && product?.bundle_variations && Object.keys(selectedAttributes).length > 1 && isValidVariation) {
      const matchingVariations = product.bundle_variations.filter(variation =>
        Object.values(selectedAttributes).some(selectedValue =>
          Object.values(variation.attrs).includes(selectedValue)
        )
      );
      const groupedAttributes = Object.entries(selectedAttributes).map(([key, _], index) => {
        const uniqueValues = [...new Set(
          matchingVariations.map(v => v.attrs[`attribute_${key}`])
        )];
        const attrDetail = matchingVariations[index]?.attrDetails?.[0]?.find(
          detail => detail.slug.replace('attribute_', '') === key
        );
        return uniqueValues.map(value => ({
          attribute: key,
          // name: key.charAt(0).toUpperCase() + key.slice(1),
          name: attrDetail?.label || key.charAt(0).toUpperCase() + key.slice(1),
          value: value,
          slug: value
        }));
      });
      return { ...product, filteredAttributes: groupedAttributes };
    } else {
      const selectedValues = new Set(
        product.bundle_variations.flatMap((variation) => Object.values(variation.attrs))
      );

      const filtered = product.bundle_attributes.map((attributeGroup) => {
        return attributeGroup
          .filter((attribute) => selectedValues.has(attribute.slug))
          .sort((a, b) => parseFloat(a.value) - parseFloat(b.value));
      });
      return { ...product, filteredAttributes: filtered };
    }

  });

  return enableBundleNumberOfPrice === 'yes'
    ? allFilteredProducts.slice(0, keyActive.value)
    : allFilteredProducts;
});
const calculateTotalPrices222 = (bundleDefaults: Record<string, IBundleDefault | null>) => {
  let regular_price = 0;
  let salePrice = 0;

  const totals = Object.values(bundleDefaults).reduce<TotalAccumulator>((acc, item, index) => {

    const discount = item.discount || 0;
    // Convert to numbers using Number() or parseFloat()
    regular_price += Number(item?.variationPrice || 0);
    const saleItem = parseFloat(discount) > 0
      ? Math.round(item?.variationPrice * (1 - parseFloat(discount) / 100))
      : (item?.variationPrice || 0);
    salePrice += Number(saleItem);
    if (item?.bundle_price) {
      const discount2 = item?.bundle_discount || 0;
      regular_price += Number(item?.bundle_price.regular_price || 0);
      const saleItem2 = parseFloat(discount2) > 0
        ? Math.round(item?.bundle_price.regular_price * (1 - parseFloat(discount2) / 100))
        : (item?.variationPrice || item?.bundle_price.regular_price);
      salePrice += Number(saleItem2);
      //salePrice += Number(item?.bundle_price.price || item?.bundle_price.regular_price)
    }
    const newAcc = {
      regularPrice: regular_price,
      salePrice: regular_price > salePrice ? salePrice : ''
    }
    // const newAcc = {
    //   regularPrice: regular_price,
    //   salePrice: regular_price
    // }
    return newAcc
  }, { regularPrice: 0, salePrice: 0 })
  const result = {
    regular_price: totals.regularPrice,
    sale_price: totals.salePrice,
    price: Number(totals.salePrice) > 0 ? totals.salePrice : totals.regularPrice
  }

  return result
}
const bundleValid = ref<string[]>([]);
const optional_checked = ref([]);
const handleCheckboxChange = (event, itemIndex, bundleID, product, discount) => {
  if (!event.target.checked) {
    const { [bundleID]: removed, ...rest } = isItemChecked.value;
    isItemChecked.value = rest;
    bundleDefaults.value[itemIndex].variationPrice = 0;
    bundleDefaults.value[itemIndex].defaultAttributes = {};
    const indexxx = parseInt(itemIndex) - 1;
    filteredAttributes.value[indexxx].filteredAttributes =
      JSON.parse(JSON.stringify(initialFilteredAttributes.value[indexxx].filteredAttributes))

    const type_bundle = bundleDefaults.value[itemIndex.toString()]?.bundle_type;
    const bundle_optional = bundleDefaults.value[itemIndex.toString()]?.bundle_optional;
    if (type_bundle == 'simple' && bundle_optional == 'yes' && perItemPricing) {
      bundleDefaults.value[itemIndex].variationPrice = 0;
      const updatedPriceInfo = calculateTotalPrices222(bundleDefaults.value);
      emit('updatePrice', updatedPriceInfo);
    }
    if (type_bundle == 'variable' && bundle_optional == 'yes' && perItemPricing) {
      bundleDefaults.value[itemIndex].variationPrice = 0;
      const updatedPriceInfo = calculateTotalPrices222(bundleDefaults.value);
      emit('updatePrice', updatedPriceInfo);
    }
    if (Object.keys(isItemChecked.value).length == 0) {
      emit('update:isStatusBundle', false);
      return;
    }

  } else {
    const { min_distinct, max_distinct } = bundleData.value.bundleAdvanceOptions;

    const defaultVariation = bundleDefaults.value[itemIndex.toString()]?.id_variation;
    const type_bundle = bundleDefaults.value[itemIndex.toString()]?.bundle_type;
    const bundle_optional = bundleDefaults.value[itemIndex.toString()]?.bundle_optional;
    if (type_bundle == 'simple' && bundle_optional == 'yes' && perItemPricing) {
      bundleDefaults.value[itemIndex].variationPrice = bundleDefaults.value[itemIndex.toString()]?.variationPriceInit;
      const updatedPriceInfo = calculateTotalPrices222(bundleDefaults.value);

      emit('updatePrice', updatedPriceInfo);
    }
    if (type_bundle == 'variable' && bundle_optional == 'yes' && perItemPricing) {
      bundleDefaults.value[itemIndex].variationPrice = bundleDefaults.value[itemIndex.toString()]?.variationPriceInit;
      const updatedPriceInfo = calculateTotalPrices222(bundleDefaults.value);

      emit('updatePrice', updatedPriceInfo);
    }

    if (defaultVariation === '' && parseInt(max_distinct) == Object.keys(isItemChecked.value).length) {

      emit('update:isStatusBundle', false);
      return;
    }

  }


  validateBundleStatus(itemIndex, bundleID, product, discount);
};

const validateBundleStatus = (currentIndex?: number, bundleID?: string, productBundle?: Product, discountty: number) => {
  const checkValue = bundleID;
  const checkedCount = Object.values(isItemChecked.value).filter(value => value === true).length;

  let bundleChildren = bundleData.value.bundleProduct;
  if (enableBundleNumberOfPrice === 'yes') {
    bundleChildren = bundleChildren.slice(0, keyActive.value)
  }
  let count = 0;
  const { min_distinct, max_distinct } = bundleData.value.bundleAdvanceOptions;

  const min = parseInt(min_distinct, 10);
  let max = parseInt(max_distinct, 10) == 0 ? bundleChildren.length : parseInt(max_distinct, 10);
  let total_optional = 0;

  let isValid = true;

  // Reset bundleValid to rebuild dynamically
  bundleValid.value = [];

  // get bunle valid bundleValid
  if (enableBundleNumberOfPrice === 'yes') {
    bundleChildren = bundleChildren.slice(0, keyActive.value);
  }
  bundleChildren.forEach(product => {
    const isMandatory = product.bundle_optional !== 'yes';
    const keyValid = product.bundle_id + '_' + product.bundle_order;

    if (product.bundle_optional !== 'yes' && parseInt(max_distinct) > 0 && enableBundleNumberOfPrice !== 'yes') {
      max -= 1;
    }
    if (product.bundle_optional == 'yes' && parseInt(max_distinct) == 0 && enableBundleNumberOfPrice !== 'yes') {
      max -= 1;
    }

    const isChecked = isItemChecked.value[keyValid];
    const isActive = isMandatory || isChecked;

    if (isActive) {
      if (product.bundle_type === 'simple') {
        if (product.bundle_stock) {
          if (!bundleValid.value.includes(keyValid)) {
            bundleValid.value.push(keyValid);
          }
        } else {
          isValid = false;
        }
      } else if (product.bundle_type === 'variable') {
        const variation = bundleDefaults.value[product.bundle_order];
        if (variation && variation.id_variation && variation.status === 'instock') {
          if (!bundleValid.value.includes(keyValid)) {
            bundleValid.value.push(keyValid);
          }
        } else {
          isValid = false;
        }
      }
    }
  });
  if (parseInt(max) > 0 && Object.keys(isItemChecked.value).length > parseInt(max) && parseInt(max_distinct) > 0 ) {
    if (currentIndex !== undefined) {
      const keyToUpdate = `${bundleID}`;
      isItemChecked.value = {
        ...isItemChecked.value,
        [keyToUpdate]: false
      };
      const { [keyToUpdate]: removed, ...rest } = isItemChecked.value;
      isItemChecked.value = rest;
      if (perItemPricing) {
        const str = keyToUpdate;
        const number = parseInt(str.split('_')[1])  // Returns 2
        bundleDefaults.value[number].variationPrice = 0;
      }

      alert(`You only can add to cart max ${max_distinct} different types.`);

    }
  }
  if (enableBundleNumberOfPrice === 'yes') {
    const activeKeys = Array.isArray(keyActive.value)
      ? keyActive.value
      : [1, 2, 3, 4, 5, 6, 7].slice(0, keyActive.value);
     
    // Check stock status - only for items that should be validated
    for (const key of activeKeys) {
     const bundleItem = bundleDefaults.value[key];
  const status = bundleItem?.status;
   console.log('--- bundleDefaults.value[key]?.status',bundleItem,status)
      
      // Get the corresponding product to check if it's mandatory or checked
      const productIndex = parseInt(key) - 1;
      const product = bundleDataProduct.value[productIndex];
      const keyValid = product?.bundle_id + '_' + product?.bundle_order;
      const isOptional = product?.bundle_optional === 'yes';
      const isChecked = isItemChecked.value[keyValid];
      
      // Only validate if: item is mandatory OR item is optional but checked
      const shouldValidate = !isOptional || isChecked;
      
      if (shouldValidate && bundleDefaults.value[key]) {
        // For variable products, only fail if they're supposed to be included but have no variation selected
        if (product?.bundle_type === 'variable') {
          if (!bundleItem?.id_variation) {
            emit('update:isStatusBundle', false)
            return false
          }
        } else if (product?.bundle_type === 'simple') {
          // For simple products, check stock
          if (bundleDefaults.value[key]?.status !== 'instock') {
            emit('update:isStatusBundle', false)
            return false
          }
          const keyvalid = key + '-' + bundleDefaults.value[key].bundle_id;
          if (!bundleValid.value.includes(keyvalid)) {
            bundleValid.value.push(keyvalid);
          }
        }
      } else if (!shouldValidate && product?.bundle_type === 'simple') {
        // For unchecked optional simple products, still add to valid if they have stock
        if (bundleDefaults.value[key].bundle_type == 'simple' && bundleDefaults.value[key]?.status === 'instock') {
          const keyvalid = key + '-' + bundleDefaults.value[key].bundle_id;
          if (!bundleValid.value.includes(keyvalid)) {
            bundleValid.value.push(keyvalid);
          }
        }
      }
    }
  }
  if (bundleValid.value.length < max || bundleValid.value.length == 0) {
    // Only apply this check when NOT in enableBundleNumberOfPrice mode
    if (enableBundleNumberOfPrice !== 'yes') {
      emit('update:isStatusBundle', false);
      return false;
    }
  }
  for (const key of Object.keys(isItemChecked.value)) {
    const id = key.split('_')[1];
    const defaultVariation = bundleDefaults.value[id]?.id_variation;

    if (defaultVariation === '') {
      emit('update:isStatusBundle', false);
      return;
    }
  }
  if (isValid && perItemPricing) {
    const calculateTotalPrices = (bundleDefaults: Record<string, IBundleDefault | null>) => {
      let regular_price = 0;
      let salePrice = 0;

      const totals = Object.values(bundleDefaults).reduce<TotalAccumulator>((acc, item, index) => {

        const discount = item.discount || 0;
        // Convert to numbers using Number() or parseFloat()
        regular_price += Number(item?.variationPrice || 0);
        const saleItem = parseFloat(discount) > 0
          ? Math.round(item?.variationPrice * (1 - parseFloat(discount) / 100))
          : (item?.variationPrice || 0);
        salePrice += Number(saleItem);


        // if (item?.bundle_price) {
        //   const discount2 = item?.bundle_discount || 0;
        //   regular_price += Number(item?.bundle_price.regular_price || 0);
        //   const saleItem2 = parseFloat(discount2) > 0
        //     ? Math.round(item?.bundle_price.regular_price * (1 - parseFloat(discount2) / 100))
        //     : (item?.variationPrice || item?.bundle_price.regular_price);
        //   salePrice += Number(saleItem2);
        //   //salePrice += Number(item?.bundle_price.price || item?.bundle_price.regular_price)
        // }
        const newAcc = {
          regularPrice: regular_price,
          salePrice: regular_price > salePrice ? salePrice : ''
        }
        // const newAcc = {
        //   regularPrice: regular_price,
        //   salePrice: regular_price
        // }
        return newAcc
      }, { regularPrice: 0, salePrice: 0 })
      const result = {
        regular_price: totals.regularPrice,
        sale_price: totals.salePrice,
        price: Number(totals.salePrice) > 0 ? totals.salePrice : totals.regularPrice
      }

      return result
    }
    // Usage:
    const updatedPriceInfo = calculateTotalPrices(bundleDefaults.value);

    emit('updatePrice', updatedPriceInfo);

  }
  if (max_distinct > 0 && Object.keys(isItemChecked.value).length < parseInt(max)) {
    isValid = false;
  }
  emit('update:isStatusBundle', isValid);
  // First check the data
  // If data is nested differently, try accessing it:
  const data = bundleData?.value?.bundleProduct || bundleData?.value;

  Object.values(data).forEach(item => {

    if (
      item.bundle_type === 'simple' &&
      item.bundle_optional !== 'yes' &&
      item.bundle_stock === false
    ) {
      emit('update:isStatusBundle', false);
      return;
    }
  });


};
const selectedVariationIds = ref<Array<{ index: number, bundleId: number; variationId: number }>>([]);

const keyActive = ref(bundleNames.length > 0 ? bundleNames[0].key : 1);
onMounted(() => {

  initialFilteredAttributes.value = JSON.parse(JSON.stringify(filteredAttributes.value));
  if (bundleNames.length > 0) {
    const defaultBundle = bundleNames[0];
    const initialPriceInfo = {
      key: defaultBundle.key,
      regular_price: defaultBundle.regularPrice,
      sale_price: defaultBundle.salePrice,
      price: Number(defaultBundle.salePrice) > 0 ? defaultBundle.salePrice : defaultBundle.regularPrice
    };
    //keyActive.value = defaultBundle.key;
    if (enableBundleNumberOfPrice == 'yes') {
      emit('updatePrice', initialPriceInfo);
    }


  }

  if (!bundleData.value?.bundleData) return;

  bundleDefaults.value = Object.keys(bundleData.value.bundleData).reduce((result, key) => {
    let key2 = parseInt(key) - 1;
    const bundleItem = bundleDataProduct.value[key2];

    if (bundleItem?.bundle_type === 'simple') {
      //result[key] = bundleItem
      result[key] = {
        id_variation: bundleItem.bundle_id,
        bundle_type: 'simple',
        bundle_optional: bundleItem?.bundle_optional,
        status: bundleItem?.bundle_stock ? 'instock' : 'outofstock',
        discount: bundleItem?.bundle_discount,
        variationPriceInit: bundleItem?.bundle_price?.regular_price || 0,
        variationPrice: bundleItem?.bundle_optional === 'yes' ? 0 : bundleItem?.bundle_price?.regular_price || 0,
        salePrice: '',
        defaultAttributes: [],
        bundle_price: {
          regular_price: '',
          price: ''
        }
      }

    } else {
      bundleVariationIdDefault.value[key] = bundleItemDefault(key)?.id_variation || ''
      result[key] = bundleItemDefault(key)
    }

    return result
  }, {} as Record<string, any>)
  
  nextTick(() => {
    validateBundleStatus();
  });

});
const isInvalid = ref(false);

const validateQuantity = (event: Event, min: number, max: number) => {
  const value = parseInt((event.target as HTMLInputElement).value);
  isInvalid.value = value < min || value > max;
};


const selectAttribute = (value: string, slug: string, bundleId: number, groupIndex: number, index: number, product: Product, attributeSlug: string, event: Event) => {
  const key = `${index}-${bundleId}-${groupIndex}`;
  selectedValues.value.set(key, value);
  openDropdowns.value.delete(key);
  const selectElement = (event.target as HTMLElement).closest('.bundled-options__select-variation')?.querySelector('.yith-wcpb-select-for-variables');
  const bundle_attributes = product.bundle_attributes;
  const attributes: { [key: string]: any[] } = {};
  bundle_attributes.forEach((attributeGroup: Attribute[]) => {
    if (attributeGroup.length > 0) {
      const attributeName = attributeGroup[0].attribute;
      attributes[attributeName] = [];
    }
  });
  const numberOfAttributes = Object.keys(attributes).length;
  //////////////////////////////update when select variation //////////////////////////////////

  if (selectElement) {
    (selectElement as HTMLSelectElement).value = slug;
  }

  const currentIndex = (index + 1).toString()

  // Initialize if not exists


  if (!bundleDefaults.value[currentIndex]) {
    bundleDefaults.value[currentIndex] = {
      id_variation: '',
      status: '',
      variationPrice: '',
      salePrice: '',
      defaultAttributes: {}
    }
  }


  // Get current attributes directly from source
  const currentAttributes = bundleDefaults.value[currentIndex].defaultAttributes;

  // Update with new value while keeping existing ones attributeSlug
  let attributeSelected = {
    ...currentAttributes,
    [groupIndex]: value
  }

  // Update bundle defaults
  bundleDefaults.value[currentIndex].defaultAttributes = attributeSelected;

  const inputElement = (event.target as HTMLElement).closest('.yith-wcpb-product-bundled-item-data')?.querySelector('.variation_id');
  const matchingVariation = product.bundle_variations.find(variation => {
    if (!variation?.attrs) return false
    const variationCount = Object.keys(variation.attrs).length
    const selectedCount = Object.keys(attributeSelected).length;

    if (variationCount !== selectedCount) return false;

    // Convert variation attrs to normalized format
    const normalizedVariationAttrs = Object.values(variation.attrs)
      .map(val => val.toLowerCase().replace('.', '-'));

    const normalizedSelectedAttrs = Object.values(attributeSelected)
      .map(val => val.toLowerCase().replace('.', '-'))
    // Check if all selected values exist in variation values
    const isMatch = normalizedSelectedAttrs.every(selectedValue =>
      normalizedVariationAttrs.includes(selectedValue)
    );

    return isMatch
  });
  if (!matchingVariation && inputElement) {
    bundleDefaults.value[currentIndex.toString()] = {
      ...bundleDefaults.value[currentIndex.toString()] ?? {},
      id_variation: '',
      status: '',
      variationPrice: '',
      salePrice: '',
      defaultAttributes: attributeSelected
    }

    emit('update:isStatusBundle', false);
  }
  if (matchingVariation) {
    const isInStock = matchingVariation.product.PostMeta.some(meta =>
      meta.meta_key === "_stock_status" && meta.meta_value === "instock"
    );
    const variationId = matchingVariation.id.toString();
    const currentIndex = (index + 1).toString();

    if (inputElement) {
      const regularPrice = matchingVariation.product.PostMeta.find(
        meta => meta.meta_key === '_regular_price'
      );

      const salePrice = matchingVariation.product.PostMeta.find(
        meta => meta.meta_key === '_price'
      );

      // Initialize if not exists
      if (bundleDefaults.value[currentIndex]) {
        // Now safely update the values
        bundleDefaults.value[currentIndex].id_variation = variationId;
        bundleDefaults.value[currentIndex].status = isInStock ? 'instock' : 'outofstock';
        bundleDefaults.value[currentIndex].variationPrice = regularPrice?.meta_value || '';
        if (perItemPricing) {
          bundleDefaults.value[currentIndex].discount = parseInt(product.bundle_discount);
          bundleDefaults.value[currentIndex].salePrice = parseInt(product.bundle_discount) > 0
            ? Math.round(regularPrice?.meta_value * (1 - parseInt(product.bundle_discount) / 100))
            : '';
        } else {
          bundleDefaults.value[currentIndex].salePrice = salePrice?.meta_value || '';
        }
      }
    }

    if (isInStock) {
      const existingIndex = selectedVariationIds.value.findIndex(item => item.bundleId === bundleId);
      if (existingIndex >= 0) {
        if (selectedVariationIds.value[existingIndex].index === index) {
          selectedVariationIds.value[existingIndex].variationId = matchingVariation.id;
        } else {
          const duplicateIndex = selectedVariationIds.value.findIndex(item =>
            item.bundleId === bundleId && item.index === index
          );
          if (duplicateIndex === -1) {
            selectedVariationIds.value.push({ index, bundleId, variationId: matchingVariation.id });
          }
        }
      } else {
        selectedVariationIds.value.push({ index, bundleId, variationId: matchingVariation.id });
      }
      const keyvalid = index + '-' + bundleId;
      if (!bundleValid.value.includes(keyvalid)) {
        bundleValid.value.push(keyvalid);
      }
    } else {
      selectedVariationIds.value = selectedVariationIds.value.filter(item => !(item.bundleId === bundleId && item.index === index));
      const keyvalid = index + '-' + bundleId;
      bundleValid.value = bundleValid.value.filter(item => item !== keyvalid);
    }
    validateBundleStatus();
  } else {
    const totalAtribute = product.bundle_attributes.length;
    const totalAtributeSelected = selectedValues.value.size;
    const oos = totalAtribute == totalAtributeSelected ? 'oos' : '';

    // Update bundle defaults with new values
    bundleDefaults.value[currentIndex.toString()] = {
      ...bundleDefaults.value[currentIndex.toString()] ?? {},
      id_variation: '',
      status: oos,
      variationPrice: '',
      defaultAttributes: attributeSelected
    }
    // Emit status update

    emit('update:isStatusBundle', false)
  }
  //validateBundleStatus();

  ////////////////////////////////////  setting variation -- filter attribue
  // Get number of properties in attributes object
  if (product.bundle_variation_ids.length > 0 && numberOfAttributes > 1) {
    if (value) {
      let matchingVariations222 = initialFilteredAttributes.value[index].bundle_variations;
      const filteredVariations = matchingVariations222.filter(variation => {
        return Object.values(attributeSelected).some(selectedValue =>
          Object.values(variation.attrs).map(attr => attr.toLowerCase())
            .includes(selectedValue.toLowerCase())
        );
      });


      const formatAttributes = (matching) => {

        return Object.keys(attributes).map(attr => {
          const values = [...new Set(
            matching.map(item => item.attrs[`attribute_${attr}`])
          )];

          // Find the matching attribute detail to get the proper label
          const attrDetail = matching[0]?.attrDetails?.[0]?.find(
            detail => detail.slug.replace('attribute_', '') === attr
          );
          return values.map(value => ({
            attribute: attr,
            name: attrDetail?.label || 'Attribute', // Will show "Bracelet Length" instead of "pa_bracelet-length"
            value: value,
            slug: value
          }));
        });
      }


      let formattedAttributes = numberOfAttributes > 1 ? formatAttributes(filteredVariations) : matchingVariations222;

      if (Object.keys(attributeSelected).length < numberOfAttributes) {
        const selectedId = parseInt(Object.keys(attributeSelected)[0]);
        // Filter only the selected group
        formattedAttributes[selectedId] = filteredAttributes.value[index].filteredAttributes[selectedId];
      }

      filteredAttributes.value[index].filteredAttributes = formattedAttributes;
    }

  }
  validateBundleStatus(currentIndex);
}

const modalImgSrc = ref("");
const modalCaption = ref("");

const show_engraving__modal = (imageUrl: string, title: string) => {
  const showEngravingModal = document.querySelector("#alt-engraving__modal");
  if (showEngravingModal) {
    modalImgSrc.value = imageUrl;
    modalCaption.value = title;
    showEngravingModal.classList.add("active");
  }
}
const close_engraving__modal = () => {
  const close_engraving__modal = document.querySelector("#alt-engraving__modal");
  if (close_engraving__modal) {
    close_engraving__modal.classList.remove("active");
  }
};

const selectedValues = ref<Map<string, string>>(new Map());
const openDropdowns = ref<Map<string, boolean>>(new Map());

const toggleDropdown = (bundleId: number, groupIndex: number, index: number) => {

  const key = `${index}-${bundleId}-${groupIndex}`;
  if (openDropdowns.value.get(key)) {
    openDropdowns.value.delete(key);
  } else {
    openDropdowns.value.clear();
    openDropdowns.value.set(key, true);
  }
}

const isDropdownOpen = (bundleId: number, groupIndex: number, index: number) => {

  const key = `${index}-${bundleId}-${groupIndex}`;
  return openDropdowns.value.get(key) || false;
}
const getAttributeName = (attributeGroup: any) => {
  if (attributeGroup) {
    return attributeGroup[0]?.name || 'Attribute';
  }
  return 'Attribute';
}
const getAttributeGroupSlug = (attributeGroup: any) => {

  if (attributeGroup) {
    return attributeGroup[0]?.attribute || 'Attribute';
  }
  return 'Attribute';
}

const clearSelection = (product: Product, bundleId: number, index: number) => {
  // Clear selections
  selectedValues.value.forEach((_, key) => {
    if (key.startsWith(`${index}-${bundleId}`)) {
      selectedValues.value.delete(key)
      openDropdowns.value.delete(key)
    }
  })
  const indexToRemove = (index + 1).toString();
  filteredAttributes.value[index].filteredAttributes =
    JSON.parse(JSON.stringify(initialFilteredAttributes.value[index].filteredAttributes))
  // }


  // Reset bundle defaults

  bundleDefaults.value[indexToRemove] = {
    id_variation: '',
    status: '',
    variationPrice: '',
    salePrice: '',
    defaultAttributes: {}
  }
  //validateBundleStatus()

  emit('update:isStatusBundle', false);
}
</script>